import ProcessorItem from "./ProcessorItem";

export default ProcessorItem;
